module.exports = __webpack_public_path__ + "static/media/ICONS_WBN_B2B_NOTIFICATION.d28d830c.svg";